// The stream currently open in the live clipping page: its moments and
// recent scored sentences. Stream metadata itself lives in live/discovery.
import { liveApi } from '@/etc/liveApi'
import { joinLiveRoom, leaveLiveRoom } from '@/store/live/socket'

const MAX_SENTENCES = 200

export default {
  namespaced: true,
  state: {
    streamId: null,
    moments: {},
    sentences: [],
    error: null,
  },
  getters: {
    moments: (state) => Object.values(state.moments).sort((a, b) => a.startTime - b.startTime),
  },
  mutations: {
    reset: (state, streamId) => {
      state.streamId = streamId
      state.moments = {}
      state.sentences = []
      state.error = null
    },
    moments: (state, list) => {
      state.moments = Object.fromEntries((list || []).map((m) => [m.momentId, m]))
    },
    moment: (state, moment) => {
      state.moments = { ...state.moments, [moment.momentId]: moment }
    },
    sentences: (state, list) => {
      state.sentences = (list || []).slice(-MAX_SENTENCES)
    },
    sentence: (state, sentence) => {
      const next = [...state.sentences, sentence]
      state.sentences = next.length > MAX_SENTENCES ? next.slice(-MAX_SENTENCES) : next
    },
    error: (state, next) => {
      state.error = next
    },
  },
  actions: {
    enter: async (store, streamId) => {
      store.commit('reset', streamId)
      const receive = (data) => {
        if (store.state.streamId !== streamId) return
        if (data?.stream) {
          store.commit('live/discovery/upsertStream', data.stream, { root: true })
          store.dispatch('live/meters/fromStream', data.stream, { root: true })
        }
        if (data?.moments) store.commit('moments', data.moments)
        if (data?.sentences) store.commit('sentences', data.sentences)
      }
      try {
        receive(await liveApi.stream(store.rootState.user.jwt, streamId))
      } catch (err) {
        store.commit('error', err.message || 'STREAM_LOAD_FAILED')
      }
      joinLiveRoom(store, { room: 'stream', streamId }, receive)
    },

    leave: async (store) => {
      const streamId = store.state.streamId
      if (!streamId) return
      store.commit('reset', null)
      await leaveLiveRoom(store, { room: 'stream', streamId })
    },

    onEvent: (store, event) => {
      const id =
        event.streamId || event.moment?.streamId || event.sentence?.streamId || event.stream?.streamId
      if (!id || id !== store.state.streamId) return
      switch (event.type) {
        case 'moment.created':
        case 'moment.updated':
          store.commit('moment', event.moment)
          break
        case 'sentence.scored':
          store.commit('sentence', event.sentence)
          break
        case 'chunk.deleted': {
          const stream = store.rootState.live.discovery.streams[id]
          if (stream && Number.isFinite(event.retentionStartTimestamp)) {
            store.commit(
              'live/discovery/upsertStream',
              { ...stream, retentionStartTimestamp: event.retentionStartTimestamp },
              { root: true }
            )
          }
          break
        }
        default:
          break
      }
    },
  },
}
